module.exports = __webpack_public_path__ + "img/Sint Eustatius.fbe3615e.svg";